import { FC, useMemo, useState } from 'react'
import moment from 'moment'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { SummarySectionPreset } from 'components/features/rewards/rewardPageSummary/SummarySectionPreset/SummarySectionPreset'
import { ChartPresetHeading } from 'components/features/rewards/rewardPage/ChartPresetHeading/ChartPresetHeading'
import { SummaryChart } from 'components/features/rewards/rewardPage/SummaryChart/SummaryChart'
import { rewardsBalanceHistorySelector } from 'selectors/bountySelectors'
import { formatUSCurrency } from 'helpers/formatHelpers'
import styles from 'components/features/rewards/rewardPageSummary/SummaryContent/SummaryContent.styl'

export type SummaryContentProps = {
}
export const SummaryContent: FC<SummaryContentProps> = () => {

  const chartData = useStoreSelector(rewardsBalanceHistorySelector)
  const [hoverIndex, setHoverIndex] = useState(0)

  const headerLabel = useMemo(() => {
    if (!chartData || hoverIndex === chartData.crypto.length - 1 || !chartData.crypto[hoverIndex]) {
      return 'TODAY'
    }

    const headerDate = moment(chartData.crypto[hoverIndex].date)
    return `${ headerDate.format('MMMM').toUpperCase() } ${ headerDate.format('Do') }`
  }, [chartData, hoverIndex])

  const headerChild = useMemo(() => {
    const cashValue = chartData?.usd[hoverIndex]?.amount ?? 0
    const cryptoValue = chartData?.crypto[hoverIndex]?.amount ?? 0

    return (
      <ChartPresetHeading
        headerLabel={ headerLabel }
        header={ formatUSCurrency(cryptoValue, 'penny') }
        cashLabel='Cash'
        cash={ cashValue }
        cryptoLabel='Crypto'
        crypto={ cryptoValue - cashValue }
      />
    )
  }, [chartData?.crypto, chartData?.usd, hoverIndex, headerLabel])

  const chartChild = useMemo(() => {
    if (!chartData || chartData.crypto.length === 0) {
      return null
    }

    return (
      <div className={ styles.summaryChartContainer }>
        <SummaryChart data={ chartData } onHover={ setHoverIndex } />
      </div>
    )
  }, [chartData])

  const isPending = useStoreSelector((state) => state.data.bounty.reward.summary?.is_pending_crypto_order_exists ?? false)

  return (
    <SummarySectionPreset
      header={ headerChild }
      main={ chartChild }
      footer={ null }
      inProgress={ isPending }
    />
  )
}
